module.exports = __webpack_public_path__ + "img/auth0.c6098f3d.png";